import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer: string;
};

type ReturnTuple = [vp.PaymentMethod[] | undefined, (_params: vp.ElinxPaymentMethodsRequest) => void, () => void];

function useFetchElinxPaymentMethods({ api, bearer }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.ElinxPaymentMethodsRequest>();
  const [response, setResponse] = useState<vp.PaymentMethod[]>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.ElinxPaymentMethodsRequest) => {
      setDataFetchingInfo(true, 'Loading', 'fullScreen');

      const res = await api.fetchElinxPaymentMethods(requestParams, source, bearer);

      setResponse(res.PaymentMethods);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) {
      sendRequest(params).catch((e) => console.error(e));
    }

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.ElinxPaymentMethodsRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse([]);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchElinxPaymentMethods);
